import { render, staticRenderFns } from "./FreeUserRegistrationMvpPage.vue?vue&type=template&id=7a159a95"
import script from "./FreeUserRegistrationMvpPage.vue?vue&type=script&lang=js"
export * from "./FreeUserRegistrationMvpPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports